import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { offerItems, offer } from '../data/offer';
import { formatARS } from '../utils/currency';
import { CtaButton } from './CtaButton';
import { Deliverables } from './Deliverables';
export function ValueStack() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full border-t border-line bg-ink py-20 sm:py-28" data-id="element-134" data-mp="1u9ydmz1xotul">
      <div className="mx-auto max-w-6xl px-4" data-id="element-135" data-mp="2hz0tc1d0ccmg">
        <h2 id="oferta-titulo" className="max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-5xl" data-id="element-136" data-mp="2i0apgl0avaqg">
          Todo lo que recibís hoy con el <span className="text-lime" data-id="element-137" data-mp="295e998i5wxt3">Pack Profe de Trail</span>
        </h2>

        <div className="mt-14 grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:gap-14" data-id="element-138" data-mp="2d6zi8irksry0">
          <ul className="divide-y divide-line border-t border-line" data-id="element-139" data-mp="30xldtake8jr4">
            {offerItems.map(item => <li key={item.title} className="flex flex-col gap-2 py-6 sm:flex-row sm:items-start sm:gap-6" data-id="element-140" data-mp="35qo8xn4tk19f">
                <CheckIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-lime" data-id="element-141" data-mp="1tfmmslt7jl1v" />
                <div className="flex-1" data-id="element-142" data-mp="1ohuu3pkqnuwm">
                  <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-mute" data-id="element-143" data-mp="234wgg63p9bs3">
                    {item.label}
                  </p>
                  <h3 className="mt-1 text-lg font-semibold text-bone" data-id="element-144" data-mp="1ycv5cni9pr3n">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-mute" data-id="element-145" data-mp="2c4jm543gp3qy">{item.description}</p>
                </div>
                <p className="shrink-0 font-display text-lg font-bold text-bone/60 sm:w-28 sm:text-right" data-id="element-146" data-mp="283psrv792wqo">
                  {formatARS(item.value)}
                </p>
              </li>)}
          </ul>

          <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-147" data-mp="2h2ush4ujsw4f">
            <div className="rounded-lg border border-lime/40 bg-panel p-7" data-id="element-148" data-mp="rr2e0rxt22uu">
              <div className="flex items-baseline justify-between border-b border-line pb-4" data-id="element-149" data-mp="mrg0sihz8mm1">
                <span className="text-sm uppercase tracking-[0.15em] text-mute" data-id="element-150" data-mp="2mtpd4csdx185">Valor total</span>
                <span className="font-display text-2xl font-bold text-mute line-through" data-id="element-151" data-mp="2rrqv0ue2qui1">
                  {formatARS(offer.totalValue)}
                </span>
              </div>

              <p className="mt-6 text-sm uppercase tracking-[0.15em] text-lime" data-id="element-152" data-mp="30sxe9b83yjez">Precio hoy</p>
              <div className="mt-1 flex items-end gap-3" data-id="element-153" data-mp="30qkq2gbrbcth">
                <span className="font-display text-5xl font-extrabold leading-none text-bone sm:text-6xl" data-id="element-154" data-mp="35r8p9pa52zys">
                  {formatARS(offer.price)}
                </span>
                <span className="pb-2 text-sm text-mute" data-id="element-155" data-mp="3fhl6b7iqwb06">pago único</span>
              </div>

              <p className="mt-2 inline-block rounded bg-lime px-2 py-1 font-display text-sm font-bold uppercase tracking-wide text-ink" data-id="element-156" data-mp="3jjyavslra2vd">
                {offer.discountLabel} · solo {offer.spots} cupos
              </p>

              <div className="mt-7 border-t border-line pt-6" data-id="element-157" data-mp="3tinrzj5tvjak">
                <Deliverables data-id="element-158" data-mp="7fvo82pdl3l0" />
              </div>

              <CtaButton className="mt-7 w-full" size="md" data-id="element-159" data-mp="7hq7zdowupni">
                Acceso inmediato
              </CtaButton>

              <p className="mt-4 flex items-center justify-center gap-2 text-xs text-mute" data-id="element-160" data-mp="2j54n5ed3puu">
                <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-161" data-mp="3tpg2ytrzmcih" />
                Pago seguro · Garantía de {offer.guaranteeDays} días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}